interface ExcludeFromBudgetCheckboxProps {
  excluded: boolean;
  onChange: (excluded: boolean) => void;
  disabled?: boolean;
}

export function ExcludeFromBudgetCheckbox({
  excluded,
  onChange,
  disabled = false,
}: ExcludeFromBudgetCheckboxProps) {
  return (
    <label className="inline-flex items-center gap-2 cursor-pointer select-none">
      <input
        type="checkbox"
        checked={excluded}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="w-4 h-4 rounded border-gray-300 text-brand-primary focus:ring-brand-primary cursor-pointer disabled:cursor-not-allowed"
      />
      <span className="text-xs text-mid-gray">Excluir del presupuesto</span>
    </label>
  );
}
